import client from './client';

export const createZipCodesApi = data => client().post('/zip-codes', data);

export const getZipCodesApi = data => client().get('/zip-codes', { params: data });

export const removeZipCodeApi = id => client().delete(`/zip-codes/${id}`);

export const editZipCodeApi = data => client().put(`/zip-codes/${data.id}`, data);
